<div
  class="cart-list-item"
  [class.not-border]="isLastItem()"
  [style.--swipe-offset.px]="swipeOffset()"
  (click)="resetSwipe()"
  sdSwipeX
  [listening]="isMobileSmDown() && !isGifted()"
  [direction]="'left'"
  (swipeMove)="onSwipeMove($event)"
  (swipeEnd)="onSwipeEnd($event)"
  (swipeDirection)="onSwipeDirection($event)"
>
  <div class="cart-list-item-top">
    <sd-cart-list-item-image [entry]="entry()"></sd-cart-list-item-image>

    <div class="cart-list-item-info">
      <div class="cart-list-item-info-title">
        <a
          class="text-b4-m-500 text-lg-b3-m-500 color-black link-black link-hover-black"
          [routerLink]="{ cxRoute: 'product', params: entry().product } | cxUrl"
        >
          {{ entry().product?.dealType }}
          {{ entry().product?.name }}
        </a>
      </div>
      <div class="cart-list-item-info-additional">
        @if (isTabletMdUp()) {
          <sd-copy-code [code]="entry().product?.code"></sd-copy-code>
        }

        @if (entry().requiredFullPayment) {
          <div class="badge text-c2-m-500 text-md-c2-l-500 color-black">товар по 100% предоплате</div>
        }
      </div>
    </div>

    @if (!isTabletMdDown()) {
      <div class="cart-list-item-counter">
        <sd-product-item-counter
          [formControl]="quantityControl()"
          [selectedPrice]="selectedPrice()"
          [max]="entry().product?.stock?.stockLevel || 1000000"
          [allowZero]="true"
          [zeroFocusEmitValue]="false"
          [isGift]="isGifted()"
        ></sd-product-item-counter>

        @if (!isGifted() && !entry().forceInStock) {
          <sd-cart-list-item-availability [entry]="entry()"></sd-cart-list-item-availability>
        }
      </div>
    }

    <div class="cart-list-item-group">
      <div class="cart-list-item-actions">
        @if (isTabletMdDown()) {
          <sd-cart-wishlist-button [productCode]="entry().product?.code"></sd-cart-wishlist-button>
        }

        @if (!isGifted() && isTabletMdUp()) {
          <sd-cart-cross-button (removeItem)="removeItem()"></sd-cart-cross-button>
        } @else if (isGifted() && !isTabletMdDown()) {
          <sd-cart-list-item-gift></sd-cart-list-item-gift>
        }
      </div>

      @if (!isTabletMdDown() && !isGifted()) {
        <sd-cart-list-item-price [entry]="entry()"></sd-cart-list-item-price>
      }
    </div>
  </div>

  @if (isTabletMdDown()) {
    <div class="cart-list-item-bottom">
      @if (isGifted()) {
        <sd-cart-list-item-gift></sd-cart-list-item-gift>
      } @else {
        <sd-cart-list-item-price [entry]="entry()"></sd-cart-list-item-price>
      }

      <div class="cart-list-item-bottom-counter">
        <sd-product-item-counter
          [formControl]="quantityControl()"
          [selectedPrice]="selectedPrice()"
          [max]="entry().product?.stock?.stockLevel || 1000000"
          [allowZero]="true"
          [zeroFocusEmitValue]="false"
          [isGift]="isGifted()"
        ></sd-product-item-counter>
      </div>
    </div>
  }
</div>

@if (isMobileSmDown()) {
  <sd-cart-list-item-mobile-delete
    (removeItem)="removeItem(true)"
    [swipeOffset]="swipeOffset()"
  ></sd-cart-list-item-mobile-delete>
}
